import { Box, Button, Loader, Text } from '@wix/design-system';
import React, { useState } from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { PremiumDomainBadge } from '../PremiumDomainBadge/PremiumDomainBadge';
import { PricingSection } from '../Pricing/PricingSection';
import { parseDomain } from '@wix/domains-serverless-interface';
export const TldAlternativeCard = _ref => {
  let recommendation = _ref.recommendation,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    dataHook = _ref.dataHook,
    _ref$useMobileLayout = _ref.useMobileLayout,
    useMobileLayout = _ref$useMobileLayout === void 0 ? false : _ref$useMobileLayout;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const _useState = useState(false),
    isClickLoading = _useState[0],
    setIsClickLoading = _useState[1];
  const _recommendation$domai = recommendation.domain,
    domain = _recommendation$domai === void 0 ? '' : _recommendation$domai,
    _recommendation$premi = recommendation.premium,
    premium = _recommendation$premi === void 0 ? false : _recommendation$premi,
    price = recommendation.price;
  const _parseDomain = parseDomain(domain),
    sld = _parseDomain.sld,
    tld = _parseDomain.tld;
  const handleClick = async () => {
    if (!onClick) {
      return;
    }
    setIsClickLoading(true);
    try {
      await onClick(recommendation);
    } finally {
      setIsClickLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    boxSizing: "border-box",
    minWidth: useMobileLayout ? undefined : '220px',
    borderRadius: "12px",
    border: "1px solid #DEDEDE",
    padding: "14px SP6",
    flex: 1,
    maxWidth: useMobileLayout ? undefined : '320px',
    gap: "SP1",
    align: "space-between",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "6px"
  }, premium && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(PremiumDomainBadge, null)), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    as: "span"
  }, sld, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, ".", tld))), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "space-between",
    verticalAlign: "bottom",
    gap: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    marginBottom: "3px"
  }, /*#__PURE__*/React.createElement(PricingSection, {
    pricing: price,
    tld: tld,
    domainName: domain,
    useMobileLayout: true
  })), /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    priority: "secondary",
    skin: "dark",
    disabled: disabled || isClickLoading,
    onClick: handleClick,
    dataHook: dataHook ? `${dataHook}-button` : undefined
  }, isClickLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : t('domain_search_suite.domain_gate.suggestions.card.cta'))));
};
//# sourceMappingURL=TldAlternativeCard.js.map